import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ActionEmployee {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

export interface ActionEmployeeSearchResult {
  payload: {
    users: ActionEmployee[];
  };
}

export interface ActionEmployeeSearchApi {
  findCachedEmployees(query: string): Observable<ActionEmployee[]>;
  queryEmployee(query: string): Observable<ActionEmployeeSearchResult>;
}

export const ACTION_EMPLOYEE_SEARCH_API =
  new InjectionToken<ActionEmployeeSearchApi>('ACTION_EMPLOYEE_SEARCH_API');
